import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as rx from "rxjs";

type Entity = models.CajaTurno;
export interface Params {
    idSucursal: number | undefined;
}
export interface Props extends kea.ModalProps<Entity, boolean, Params> {
}

function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        RubroCaja: validation.required,
        IdCaja: validation.required
    }
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un CajaTurno
*/
export class CajaTurnoEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));


    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    idCaja = (x: Props) => x.value.IdCaja as number | undefined;

    render() {
        const value = this.props.value;
        const hasError = this.hasError(this.props);

        const getField = this.getField;
        const Rubro = getField(selectores.RubroCaja);
        const Caja = getField(selectores.Caja)

        //TODO: Deshabilitar el boton segun las validaciones
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError}  />]}
                onClose={this.onCerrar}
                title="Editar caja"
            >

                {kea.autogrid(6, [
                    <Rubro field="RubroCaja" label="Rubro" />,
                    <Caja field="IdCaja" label="Caja" filtro= {{
                        idSucursal: this.props.params.idSucursal
                    }} />
                ])}
            </kea.Modal>
        )
    }
}   



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/edit/cajas/editmodal.tsx